import { Injectable, inject } from "@angular/core";
import { EMPTY, type Observable, defer, of } from "rxjs";
import { PendoProfile } from "../../pendo-profile.model";
import type { PendoProfileSource } from "../pendo-profile-source";
import { PendoIdsLocalStorageCacheService } from "./pendo-ids-local-storage-cache.service";

/** The ids this device last saw for the same session. */
@Injectable()
export class LocalStorageProfileSource implements PendoProfileSource {
    private readonly _cache = inject(PendoIdsLocalStorageCacheService);

    contribute$(token: string): Observable<PendoProfile> {
        return defer(() => {
            const ids = this._cache.read(token);
            return ids ? of(PendoProfile.fromIds(ids)) : EMPTY;
        });
    }

    remember(token: string, ids: PendoProfile.Ids): void {
        this._cache.write(token, ids);
    }
}
